<div class="modal-form container" mat-dialog-container>
    
    <div class="Vert-25"></div>
    
    <mat-dialog-content class="mat-typography">
        <h2 class="jumbotron-heading">{{title}}</h2>
        <div>{{subtitle}}</div>
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

        <div class="edit">

            <div [formGroup]="socialMediaFG" class="form showUnTouchedInvalidFields">
                <div formArrayName="socialMediaArray">

                    <div *ngIf="socialMediaArray && socialMediaArray?.controls?.length == 0">
                        There is currently no social media added.  Click the "Add Social Channel" below to get started.
                    </div>
                    <div class="col-12 Vert-25"></div>

                    <ng-container *ngFor="let slForm of socialMediaArray.controls; let i = index">
                        <div [formGroup]="slForm" class="row">

                            <div class="col-12">
                                <mat-form-field appearance="outline" floatLabel="always">
                                    <mat-label>Url</mat-label>
                                    <input type="text" matInput formControlName="url">
                                </mat-form-field>
                            </div>


                            <mat-form-field class="col-11" appearance="outline" floatLabel="always" title="Description" *ngIf="socialMediaOptions">
                                <mat-label>Type</mat-label>
                                <mat-select formControlName="socialMediaTypeId">
                                    <mat-option *ngFor="let item of socialMediaOptions" [value]="item.ID">
                                        {{item.Display}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="col-1 trashCanAdjustment">
                                <a class="buttonIcon grayIcon" (click)="removeSocialMedia(i)"><fa-icon icon="trash"></fa-icon></a>
                            </div>
                            <!--<div class="d-lg-none col-12 Vert-25"></div>-->

                            <div class="col-12 Vert-15"></div>
                        </div>

                    </ng-container>
                </div>

            </div>
            <div class="Vert-25"></div>
            <div class="row">
                <div class="col-12">
                    <a (click)="onAddSocialMedia(null, null)"><fa-icon icon="plus"></fa-icon> Add Social Channel</a>
                    <div class="Vert-25"></div>
                </div>
            </div>


            <div class="Vert-10"></div>

            <div class="row">
                <div class="col-12" align="end">

                    <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                            [disabled]="(isLoading$ | async) || !socialMediaFG.valid">
                        Submit
                    </button>

                    <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                            style="margin-right:10px;">
                        Cancel
                    </button>
                </div>
            </div>
            <div class="Vert-15"></div>

        </div>


    </mat-dialog-content>

</div>
